import styles from 'partials/dashboard/user-content.module.scss';

export const ContentBox = ({
	children,
	icon,
	title,
	subtitle,
	headerButton
}) => {
	const Icon = icon;
	return (
		<div className={styles.box}>
			<div className={styles.headerBox}>
				<header className={styles.header}>
					<div className={styles.headerTop}>
						<Icon size="22" className={styles.headerIcon} />
						<h4 className={styles.headerTitle}>{title}</h4>
					</div>
					{headerButton && headerButton}
				</header>
				{subtitle && (
					<span className={styles.headerSubtitle}>{subtitle}</span>
				)}
			</div>
			<div className={styles.content}>{children}</div>
		</div>
	);
};
